import { Component, input } from '@angular/core';
import { TranslationPipe } from '@prekog/common-ui';

@Component({
	selector: 'pf-offer-header',
	templateUrl: './offer-header.component.html',
	styleUrls: ['./offer-header.component.scss'],
	standalone: true,
	imports: [TranslationPipe],
})
export class OfferHeaderComponent {
	title = input.required<string>();
	lines = input<string[]>([]);
	translateTitle = input<boolean>(false);
}
